interface SectionHeadingProps {
  imgSrc: string;
  alt: string;
  /** 하단 여백 제거 — 다음 컨텐츠가 자체 상단 여백을 가질 때 */
  noMargin?: boolean;
  /** 이미지에 `relative z-[1]` 적용 — absolute 형제(예: 폴라로이드) 위에 올릴 때 */
  raised?: boolean;
}

export function SectionHeading({
  imgSrc,
  alt,
  noMargin = false,
  raised = false,
}: SectionHeadingProps) {
  return (
    <div className={`text-center ${noMargin ? "" : "mb-[60px]"}`}>
      <img
        src={imgSrc}
        alt={alt}
        className={`h-[100px] max-md:h-[64px] w-auto mx-auto block ${raised ? "relative z-[1]" : ""}`}
      />
      <div className="w-10 h-px bg-[var(--ip-primary)] mx-auto mt-5" />
    </div>
  );
}
